/** @jsx h */
import { h } from 'preact'

const PhotoIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='56'
    height='56'
    viewBox='0 0 56 56'
  >
    <g fill='none' fillRule='evenodd'>
      <circle cx='28' cy='28' r='28' fill='#FFF' />
      <rect
        width='22'
        height='28'
        x='21'
        y='14'
        fill='#2F3A4A'
        fillOpacity='0.5'
        rx='2'
        transform='rotate(6 32 28)'
      />
      <g transform='rotate(-12 78.843 -36.586)'>
        <path
          fill='#FFF'
          stroke='#2F3A4A'
          strokeWidth='1.5'
          d='M2 0h18a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z'
        />
        <path
          fill='#2F3A4A'
          fillOpacity='0.5'
          d='M2 20l5.84-7.189a1 1 0 0 1 1.441-.117l2.696 2.397a1 1 0 0 0 1.579-.341l2.962-6.666a1 1 0 0 1 1.469-.426l1.568 1.045a1 1 0 0 1 .445.832V20H2z'
        />
        <circle cx='7' cy='7' r='3' fill='#2F3A4A' fillOpacity='0.5' />
      </g>
    </g>
  </svg>
)

export default PhotoIcon
